module.exports = __webpack_public_path__ + "static/media/report2017.6df88ebd.pdf";